import type { PlanScreen } from '../PlanGameView';

// The wizard's step sequence, extracted so the style-of-play gate is testable
// without standing up the whole screen.
//
// Steps 1 and 4 are pitching steps. Coach pitch, T-ball and machine pitch have no
// pitch counts at all (feature activation is gated on `styleOfPlay` throughout
// the app), so those teams get a three-step wizard and must never be asked to
// name a starting pitcher or queue relievers.

export const PITCHING_STEPS: PlanScreen[] = ['pitcher', 'defense', 'order', 'bullpen', 'review'];
export const NON_PITCHING_STEPS: PlanScreen[] = ['defense', 'order', 'review'];

export function stepSequenceFor(hasPitchCounts: boolean): PlanScreen[] {
  return hasPitchCounts ? PITCHING_STEPS : NON_PITCHING_STEPS;
}

/** "STEP 2 OF 5". Empty for screens that sit outside the numbered sequence. */
export function stepLabelFor(sequence: PlanScreen[], screen: PlanScreen): string {
  const i = sequence.indexOf(screen);
  return i >= 0 ? `STEP ${i + 1} OF ${sequence.length}` : '';
}

/** Next screen in the sequence; the review card is always the terminus. */
export function nextScreen(sequence: PlanScreen[], from: PlanScreen): PlanScreen {
  const i = sequence.indexOf(from);
  return i >= 0 && i < sequence.length - 1 ? sequence[i + 1] : 'review';
}

/** Previous screen; stepping back off the first step returns to the entry menu. */
export function prevScreen(sequence: PlanScreen[], from: PlanScreen): PlanScreen {
  const i = sequence.indexOf(from);
  return i > 0 ? sequence[i - 1] : 'entry';
}
